import api from 'services/api'
import { downloadFile } from 'services/utils'

export const downloadAttachment = (attachment) =>
  downloadFile(`/order-attachments/${attachment.id}`, attachment.filename)

export const downloadFileByOrderToken = (attachment, token) =>
  downloadFile(`/contractor-view/attachment/${attachment.id}?orderToken=${token}`, attachment.filename)

export const downloadContractorFile = (file) =>
  downloadFile(`/contractors/files/${file.id}`, file.filename)

export const downloadCarFile = (file) =>
  downloadFile(`/car-files/${file.id}`, file.filename)

export const downloadDriverFile = (file) =>
  downloadFile(`/driver-files/${file.id}`, file.filename)

export const getOrderAttachment = (attachment) =>
    api.get(`/order-attachments/${attachment.id}`,
        { responseType: 'blob' });

export const getOrderAttachmentByToken = (attachment, token) =>
    api.get(`/contractor-view/attachment/${attachment.id}?orderToken=${token}`,
        { responseType: 'blob' });

export const getContractorFile = (file) =>
    api.get(`/contractors/files/${file.id}`,
      { responseType: 'blob' });

export const getCarFile = (file) =>
  api.get(`/car-files/${file.id}`,
    { responseType: 'blob' });

export const getDriverFile = (file) =>
  api.get(`/driver-files/${file.id}`,
    { responseType: 'blob' });
